import React from 'react';
import { VehicleDetailsLightBoxStore } from '../../_flux/stores/vehicle_details_light_box_store';
import { VehicleDetailsLightBox } from '../../_flux/components/vehicle_details_light_box/vehicle_details_light_box';
import { expandAction, hideAction } from '../../_flux/actions/vehicle_details_light_box_actions';
import LightboxStore from '../../_flux/stores/lightbox_store';
import { clickOnLearnMore, close } from '../../_modules/google_analytics/vehicle_details_light_box';
import { handleView } from '../handle_view';

const stores = {
    vehicleDetailsLightBox: VehicleDetailsLightBoxStore,
    lightBox: LightboxStore,
};

function render(
    {
        vehicleDetailsLightBox,
        lightBox,
    },
) {
    const { visible, expanded } = vehicleDetailsLightBox;
    const LightBoxVisible = lightBox.visible;
    
    return (
        <VehicleDetailsLightBox
            visible={visible}
            expanded={expanded}
            LightBoxVisible={LightBoxVisible}
            onExpand={onExpand}
            onClose={onClose}
        />
    );
}

const getOptions = options => ({
    ...options,
});

export const init = (container, options) =>
    handleView(stores, render, getOptions(options), container);

const onExpand = () => {
    expandAction();
    clickOnLearnMore();
};

export const onClose = () => {
    hideAction();
    close();
};